import { useState, useCallback } from "react";
import { importHistoryAdminAPI } from "../../../hooks/importHistory/importHistoryAdminAPI";
import { ImportHistoryAdmin } from "../../../hooks/importHistory/types/typesAdmin";
interface ImportStatus extends ImportHistoryAdmin {}
export function useImportHistory(token: string) {
  const [importHistory, setImportHistory] = useState<ImportStatus[]>([]);
  const [isFetchingHistory, setIsFetchingHistory] = useState<boolean>(false);
  const fetchImportHistory = useCallback(async () => {
    setIsFetchingHistory(true);
    try {
      const response = await importHistoryAdminAPI.getAll("", 1, token, 100);
      setImportHistory(response.import_histories);
    } catch (error) {
      console.error("Erro ao buscar históricos de importação:", error);
    } finally {
      setIsFetchingHistory(false);
    }
  }, [token]);
  return {
    importHistory,
    isFetchingHistory,
    fetchImportHistory,
    setImportHistory,
  };
}
